<template>
    <Modal
      :title="'Update Timezone'"
      v-model="timezoneUpdateOpen"
      :handleClose="closeTimezoneModalHandler"
    >
      <p class="text-md font-semibold">There is a change in your Timezone. Would you like to update into your profile ?</p>
      <div class="w-full p-2">
          <label class="block mb-1"> FitClass Timezone</label>
          <input
            type="text"
            class="w-full h-10 px-3 cursor-not-allowed text-base placeholder-gray-600 border-1 border-borderColor rounded-lg focus:outline-none"
            disabled
            :value="userTimeZone"
          />
      </div>
      <div class="w-full p-2">
        <label class="block mb-1"> Current Timezone </label>
        <input
        type="text"
        disabled
        class="w-full cursor-not-allowed h-10 px-3 text-base placeholder-gray-600 border-1 border-borderColor rounded-lg focus:outline-none"
        :value="browserTimeZone"
        />
      </div>
      <div class="flex items-center justify-end">
        <button
          type="button"
          class="inline-flex items-center h-10 px-4 m-2 text-green-light transition-colors duration-150 ring-green-light rounded-lg focus:outline-none hover:bg-green-light hover:text-white ring-1"
          @click="closeTimezoneModalHandler"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="h-10 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline"
          @click.prevent="updateTimeZoneHandler"
        >
          Update Timezone
        </button>
      </div>
    </Modal>
</template>
<script>
import Modal from "@/components/t-components/Modal.vue";
import * as Cookies from 'js-cookie'
export default {
  name: "UpdateTimeZoneModal",
  components: {
    Modal
  },
  data () {
    return {
      timezoneUpdateOpen: false
    }
  },
  mounted () {
    this.checkTimezoneChanges() 
  },
  computed: {
    browserTimeZone () {
      return this.getBrowserTimeZone()
    },
    userTimeZone () {
      return this.getUserTimeZone()
    }
  },
  methods: {
    checkTimezoneChanges () {
      const isTimeZoneCookieSet = Cookies.get('fitclass_timezoneFlag')
      if (this.userTimeZone && this.userTimeZone.length && this.userTimeZone !== this.browserTimeZone && !isTimeZoneCookieSet) {
        this.timezoneUpdateOpen = true
      }
    },
    closeTimezoneModalHandler () {
      this.toggleTimezoneModal()
      const expirationDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000) // Expires in 1 day
      Cookies.set('fitclass_timezoneFlag', 'hidden', {
        expires: expirationDate,
        secure: true
      })
    },
    toggleTimezoneModal () {
      this.timezoneUpdateOpen = !this.timezoneUpdateOpen
    },
    updateLocalTimezone () {
      let user = JSON.parse(localStorage.getItem("user"));
      user.timezone = this.browserTimeZone;
      localStorage.setItem("user", JSON.stringify(user));
    },
    updateTimeZoneHandler () {
      this.$store.dispatch('updateTimeZoneData', this.browserTimeZone).then((res) => {
        this.toggleTimezoneModal();
        this.updateLocalTimezone();
        this.$store.commit("setIsSuccess", res && res.message);
      }).catch((err) => {
        this.$store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
      })
    }
  }
}
</script>